import { Typography, Divider, List, ListItem, ListItemText, Box, ListItemIcon } from '@mui/material';
import React from 'react';

import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import { colors } from '../../constants/constants';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
function SimpleHeadingAndText({ heading, value, isResponseAvailable = true, Icon = CheckBoxOutlineBlankOutlinedIcon }) {
  const renderContent = () => {
    switch (typeof value) {
      case 'string':
        return <Typography fontSize={"15px"}>{value}</Typography>;
      case 'object':
        if (Array.isArray(value)) {
          return (
            <List sx={{padding:'0px'}}>
              {value.map((item, index) => (
                <ListItem key={index} sx={{padding:'0px',alignItems:'baseline'}}>
                    <ListItemIcon sx={{ minWidth: '24px' }}>
            <FiberManualRecordIcon sx={{ fontSize: '7px',color:"white" }} />
          </ListItemIcon>
                  <ListItemText sx={{fontSize:"15px"}} primary={item} />
                </ListItem>
              ))}
            </List>
          );
        } else if (value !== null) {
          return (
            <List>
              {Object.entries(value).map(([key, val], index) => (
                <ListItem key={index} sx={{padding:'0px',alignItems:'baseline'}}>
                    <ListItemIcon sx={{ minWidth: '24px' }}>
            <FiberManualRecordIcon sx={{ fontSize: '7px',color:"white" }} />
          </ListItemIcon>
                  <ListItemText sx={{fontSize:"15px"}}  primary={`${key}: ${val}`} />
                </ListItem>
              ))}
            </List>
          );
        }
        return <Typography>Unsupported datatype</Typography>;
      default:
        return <Typography>Unsupported datatype</Typography>;
    }
  };

  return (
    <>
    <Box sx={{display:'flex',alignItems:'center',gap:'10px'}}>
      { Icon != CheckBoxOutlineBlankOutlinedIcon && (<Icon sx={{color:colors.appLightBlue}}   />) }
    
    <Typography  sx={{fontWeight:'700',fontSize:'1.3rem'}}>
     {heading}
      </Typography>
    </Box >
     <Box sx={{color:colors.appTextGray}}>
     {value ? (
        renderContent()
      ) : (
        isResponseAvailable && (
          <Typography>No information related to this could be found.</Typography>
        )
      )}
     </Box>
     
      <Divider sx={{ margin: '16px 0', borderColor: colors.appTextGray,borderWidth: '0.1px'}} />
    </>
  );
}

export default SimpleHeadingAndText;
